import React, { useRef } from 'react';
interface PBprops {
  bgcolor: string;
  progress: number;
  onSeek?: any;
}
const ProgressBar = (props: PBprops) => {
  const { bgcolor, progress } = props;
  const container = useRef(null);

  if (progress < 0  || progress > 100) {
    return <></>;
  }

  const handleClick = (ev) => {
    console.log(ev);
    if (ev) {
      ev.stopPropagation();
    }
    if (container && container.current) {
      const bcr = (container.current as HTMLElement).getBoundingClientRect();
      const position = Math.min(Math.max(0, (ev.clientX - bcr.left) / bcr.width), 1);

      if (props.onSeek) {
        props.onSeek(position);
      }
    }
  }

  return (
    <div style={{ height: 8, marginTop: 2, width: '100%', backgroundColor: "#e0e0de", borderRadius: 8, cursor: 'pointer' }} ref={container} onClick={(e) => handleClick(e)}>
      <div style={{ height: '100%', width: `${progress}%`, background: bgcolor, borderRadius: 'inherit', textAlign: 'right', transition: 'width 200ms linear' }}>
        {/* <span style={{ padding: 5, color: 'white', fontWeight: 'bold' }}>{`${completed}%`}</span> */}
      </div>
    </div>
  );
};

export default ProgressBar;